import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/undelivered-orders/store/selectors';
import { UndeliveredParams } from '@api/order-reporting/types/UndeliveredParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/undelivered-orders/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetUndeliveredOrdersMutation } from '@api/order-reporting/api';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/undelivered-orders/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/undelivered-orders/grid/Grid';
import { headersObject } from '@pages/reporting-pages/undelivered-orders/headersObject';



const UndeliveredOrders = () => {
	
	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();

	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: UndeliveredParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ resetUndeliveredOrders ] = useResetUndeliveredOrdersMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');
			let paramDc = search.get('dc');
			let paramPhase = search.get('phase');

			if (!paramDateFrom || !paramDateTo) return;

			let newSearchParams: UndeliveredParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
				...(paramDc && { dc: paramDc }),
				...(paramPhase && { phase: paramPhase }),
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		resetUndeliveredOrders();
	},[]);


	return (
		<AppPage
			className='reporting-page undelivered-orders'
			pageLabel='Report - Nedoručené objednávky'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-nedorucene-objednavky',
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default UndeliveredOrders;